<template>
  <ul data-animate="list" class="listing-list">
    <li
      v-for="item in items"
      :key="item.id"
      :class="{
        '--large-item': item?.largeItem,
        '--filtered-item': item?.filtered,
      }"
    >
      <!-- <div v-anim-scroll-speed="{ factor: (index - 1) % 3 === 0 ? 0.2 : 0 }">-->
      <!--<div
        class="listing-list__item"
        v-anim-parallax-element="{
          target: 'picture',
        }"
      >-->
      <div class="listing-list__item">
        <WidgetContentBlock :content="item" :key="item.id" />
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'ListingList',
}
</script>

<script setup>
const props = defineProps({
  items: Array,
})
</script>

<style lang="scss">
@import './style.scss';
</style>
